import { render, staticRenderFns } from "./cwbsck.vue?vue&type=template&id=70bb2ce0"
import script from "./cwbsck.vue?vue&type=script&lang=js"
export * from "./cwbsck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports